import React, { useRef } from 'react'
import {
  Text,
  Image,
  Box,
  Link,
  Card,
  CardBody,
  Stack,
  Heading,
  Divider,
  CardFooter,
} from '@chakra-ui/react'
import { motion, useScroll, useTransform } from 'framer-motion'

const ProjectBrief = ({ projectDetail }) => {
  // Fade up transition
  const ref = useRef(null)

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['0 1', '1.33 1'],
  })
  const scaleProgress = useTransform(scrollYProgress, [0, 1], [0.8, 1])
  const opacityProgress = useTransform(scrollYProgress, [0, 1], [0.6, 1])

  return (
    <motion.div
      key={projectDetail.id}
      style={{
        scale: scaleProgress,
        opacity: opacityProgress,
      }}
      ref={ref}>
      <Card className='card' maxW='sm'>
        <CardBody>
          <Link href={projectDetail.projectLink}>
            <Image
              className='card-img'
              src={projectDetail.src}
              alt={projectDetail.alt}
              borderRadius='lg'
            />
          </Link>
          <Stack mt='6' spacing='3' className='card-content'>
            <Heading size='md'>{projectDetail.name}</Heading>
            <Text>{projectDetail.info}</Text>
            <Link className='in-depth-click' href={projectDetail.projectLink}>
              <Text color='olive' fontSize='xl'>
                Click me to see in-depth details
              </Text>
            </Link>
          </Stack>
        </CardBody>
        <Divider />
        <CardFooter>
          <Text color='blue.600' fontSize='2xl' fontFamily='Shadows Into Light'>
            {projectDetail.footerInfo}
          </Text>
        </CardFooter>
      </Card>
    </motion.div>
  )
}

export default ProjectBrief
